import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { Box } from '@material-ui/core';
import {
  Footer,
  LayoutSideNavigation,
  LayoutWrapperFooter,
  LayoutWrapperMain,
  LayoutWrapperSideNav,
  LayoutWrapperTopbar,
  Page,
  TypographyWrapper,
} from '../../components';
import { useShopConfig } from '../../hooks/shopConfig';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import Subprocessors from './Subprocessors';
import { isScrollingDisabled } from '../../ducks/UI.duck';
import { useFeatureFlags } from '../../hooks/useFeatureFlags';
import { Feature } from '../../util/featureFlags';

const SubprocessorsPage: FC = () => {
  const intl = useIntl();
  const { treetShopName } = useShopConfig();
  const scrollingDisabled = useSelector<any>((state) => isScrollingDisabled(state));
  const isCookieConsentEnabled = useFeatureFlags(Feature.CookieConsent);

  const tabs = [
    {
      text: intl.formatMessage({ id: 'SubprocessorsPage.privacyTabTitle' }),
      selected: false,
      linkProps: {
        name: 'PrivacyPolicyPage',
      },
    },
    ...(isCookieConsentEnabled
      ? [
          {
            text: intl.formatMessage({ id: 'SubprocessorsPage.cookieTabTitle' }),
            selected: false,
            linkProps: {
              name: 'CookiePolicyPage',
            },
          },
        ]
      : []),
    {
      text: intl.formatMessage({ id: 'SubprocessorsPage.subprocessorsTabTitle' }),
      selected: true,
      linkProps: {
        name: 'SubprocessorsPage',
      },
    },
    {
      text: intl.formatMessage({ id: 'SubprocessorsPage.tosTabTitle' }),
      selected: false,
      linkProps: {
        name: 'TermsOfServicePage',
      },
    },
  ];

  const schemaTitle = `Subprocessor | ${treetShopName}`;
  const schema = {
    '@context': 'http://schema.org',
    '@type': 'WebPage',
    name: schemaTitle,
  };

  return (
    <Page title={schemaTitle} scrollingDisabled={scrollingDisabled} schema={schema}>
      <LayoutSideNavigation>
        <LayoutWrapperTopbar>
          <TopbarContainer currentPage="SubprocessorsPage" />
        </LayoutWrapperTopbar>
        <LayoutWrapperSideNav tabs={tabs} />
        <LayoutWrapperMain>
          <Box maxWidth="563px">
            <Box mt={1} mb={4}>
              <TypographyWrapper variant="h1">Subprocessors</TypographyWrapper>
            </Box>
            <Subprocessors />
          </Box>
        </LayoutWrapperMain>
        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSideNavigation>
    </Page>
  );
};

export default SubprocessorsPage;
